/**
 * Energy AI Bot API Types & Interfaces
 */

export interface ChatMessageHistory {
  role: "user" | "assistant" | "system";
  content: string;
}

export interface ChatStreamRequest {
  message: string;
  session_id?: string;
  recaptcha_token?: string;
  history?: ChatMessageHistory[];
}

export interface StreamEventChunk {
  content: string;
  done: boolean;
  session_id?: string;
}

export interface StandardApiResponse<T = any> {
  code: number;
  message: string;
  data?: T;
}

export type EnergyBotErrorType =
  | "RATE_LIMIT_EXCEEDED"
  | "CAPTCHA_REQUIRED"
  | "CAPTCHA_FAILED"
  | "NETWORK_ERROR"
  | "HTTP_ERROR"
  | "ABORTED";

export class EnergyBotApiError extends Error {
  public type: EnergyBotErrorType;
  public status?: number;

  constructor(type: EnergyBotErrorType, message: string, status?: number) {
    super(message);
    this.name = "EnergyBotApiError";
    this.type = type;
    this.status = status;
  }
}
